// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * QR 출력 - QR 스티커 출력 페이지 스타일
 */

.qrprint-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #FFF8E1 0%, #E8F5E9 100%);
  display: flex;
  flex-direction: column;
}

/* 헤더 */
.qrp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.qrp-header-center {
  display: flex;
  align-items: center;
  gap: 10px;
  user-select: none;
  -webkit-user-select: none;
  cursor: pointer;
}

.qrp-header h1 {
  font-family: 'Jua', sans-serif;
  font-size: 22px;
  color: #2E7D32;
  margin: 0;
  user-select: none;
  -webkit-user-select: none;
}

.qrp-header-spacer {
  width: 72px;
}

.qrp-header .btn-back {
  background: none;
  border: 2px solid #66BB6A;
  color: #2E7D32;
  font-size: 15px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s;
}

.qrp-header .btn-back:active {
  background: #66BB6A;
  color: #fff;
}

/* 콘텐츠 */
.qrp-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 20px;
  overflow: hidden;
}

/* 검색 섹션 */
.qrp-search-section {
  width: 100%;
  max-width: 300px;
  text-align: center;
}

.qrp-desc {
  font-family: 'Jua', sans-serif;
  font-size: 15px;
  color: #2E7D32;
  line-height: 1.4;
  margin-bottom: 8px;
}

/* 전화번호 표시 */
.qrp-phone-display {
  background: #fff;
  border: 3px solid #C8E6C9;
  border-radius: 12px;
  padding: 10px 12px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qrp-phone-text {
  font-family: 'Jua', sans-serif;
  font-size: 26px;
  color: #2E7D32;
  letter-spacing: 2px;
  user-select: none;
  -webkit-user-select: none;
  pointer-events: none;
}

.qrp-phone-text.placeholder {
  color: #C8E6C9;
}

/* 숫자패드 */
.qrp-numpad {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.qrp-numpad-row {
  display: flex;
  gap: 6px;
  justify-content: center;
}

.qrp-numpad-key {
  width: 76px;
  height: 42px;
  border: none;
  border-radius: 10px;
  background: #fff;
  color: #333;
  font-family: 'Jua', sans-serif;
  font-size: 22px;
  cursor: pointer;
  transition: background 0.1s, transform 0.1s;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.qrp-numpad-key:active {
  background: #E8F5E9;
  transform: scale(0.95);
}

.qrp-numpad-key.key-clear {
  background: #FFEBEE;
  color: #C62828;
  font-size: 17px;
}

.qrp-numpad-key.key-clear:active {
  background: #FFCDD2;
}

.qrp-numpad-key.key-backspace {
  background: #FFF3E0;
  color: #E65100;
  font-size: 20px;
}

.qrp-numpad-key.key-backspace:active {
  background: #FFE0B2;
}

/* 조회 버튼 */
.qrp-search-section .btn-search {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #66BB6A, #43A047);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
  margin-top: 2px;
}

.qrp-search-section .btn-search:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.qrp-search-section .btn-search:not(:disabled):active {
  transform: scale(0.97);
}

/* 에러 */
.qrp-error {
  margin-top: 16px;
  padding: 12px 16px;
  background: #FFEBEE;
  color: #C62828;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
}

/* 로딩 */
.qrp-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 80px;
}

.qrp-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #C8E6C9;
  border-top-color: #66BB6A;
  border-radius: 50%;
  animation: qrp-spin 0.8s linear infinite;
}

@keyframes qrp-spin {
  to { transform: rotate(360deg); }
}

.qrp-loading p {
  font-size: 16px;
  color: #546E7A;
}

/* 결과 섹션 */
.qrp-result-section {
  width: 100%;
  max-width: 440px;
  animation: qrp-fadeIn 0.3s ease;
}

@keyframes qrp-fadeIn {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 전화번호 배너 */
.qrp-phone-banner {
  text-align: center;
  font-family: 'Jua', sans-serif;
  font-size: 18px;
  color: #2E7D32;
  background: #E8F5E9;
  border-radius: 12px;
  padding: 10px;
  margin-bottom: 10px;
}

/* 선택 컨트롤 */
.qrp-select-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.btn-select-ctrl {
  padding: 8px 14px;
  background: #fff;
  color: #555;
  border: 2px solid #E0E0E0;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: all 0.15s;
}

.btn-select-ctrl.active {
  background: #E8F5E9;
  border-color: #66BB6A;
  color: #2E7D32;
}

.btn-select-ctrl:active {
  transform: scale(0.95);
}

.qrp-select-count {
  margin-left: auto;
  font-family: 'Jua', sans-serif;
  font-size: 15px;
  color: #777;
}

/* 회원 카드 리스트 */
.qrp-member-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
  max-height: calc(100vh - 340px);
  overflow-y: auto;
}

.qrp-member-item {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border: 2px solid #E0E0E0;
  border-radius: 14px;
  padding: 10px 14px;
  cursor: pointer;
  transition: all 0.15s;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.qrp-member-item.selected {
  border-color: #66BB6A;
  background: #F1F8E9;
}

.qrp-member-item:active {
  transform: scale(0.98);
}

.qrp-member-check {
  font-size: 22px;
  flex-shrink: 0;
}

.qrp-member-qr {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qrp-member-qr img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.qrp-no-qr {
  font-size: 11px;
  color: #999;
}

.qrp-member-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.qrp-member-label {
  font-family: 'Jua', sans-serif;
  font-size: 17px;
  color: #333;
}

.qrp-member-type {
  font-size: 12px;
  color: #999;
}

/* 액션 버튼 */
.qrp-action-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.btn-print {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #66BB6A, #43A047);
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 18px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
}

.btn-print:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.btn-print:not(:disabled):active {
  transform: scale(0.97);
}

.qrp-action-buttons .btn-reset {
  width: 100%;
  padding: 14px;
  background: #E0E0E0;
  color: #555;
  border: none;
  border-radius: 14px;
  font-size: 17px;
  font-weight: 700;
  font-family: 'Jua', sans-serif;
  cursor: pointer;
  transition: transform 0.15s;
}

.qrp-action-buttons .btn-reset:active {
  transform: scale(0.97);
}

/* 전체화면 복귀 오버레이 */
.qrp-fs-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
  cursor: pointer;
  animation: qrp-fadeIn 0.2s ease;
}

.qrp-fs-popup {
  background: #fff;
  border-radius: 20px;
  padding: 32px 28px;
  max-width: 320px;
  width: 90%;
  text-align: center;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.3);
}

.qrp-fs-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

.qrp-fs-popup h3 {
  font-family: 'Jua', sans-serif;
  font-size: 20px;
  color: #333;
  margin: 0 0 8px;
}

.qrp-fs-popup p {
  font-size: 15px;
  color: #666;
  margin: 0;
  line-height: 1.4;
}

/* ============================================
 * 인쇄 전용 스타일 (화면에는 숨김)
 * ============================================ */

.qrp-print-area {
  display: none;
}

@media print {
  /* 글로벌 요소 초기화 */
  html, body {
    background: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .app {
    min-height: auto !important;
    display: block !important;
  }

  .qrprint-page {
    min-height: auto !important;
    background: none !important;
    display: block !important;
  }

  .qrp-header,
  .qrp-content,
  .qrp-fs-overlay {
    display: none !important;
  }

  /* 인쇄 영역 표시 */
  .qrp-print-area {
    display: flex !important;
    flex-wrap: wrap;
    gap: 4mm;
    padding: 2mm;
    justify-content: flex-start;
  }

  /* QR 스티커 한 장 */
  .qrp-sticker {
    width: 40mm;
    height: 45mm;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 0.5px dashed #ccc;
    padding: 2mm;
    page-break-inside: avoid;
  }

  .qrp-sticker-qr {
    width: 32mm;
    height: 32mm;
    object-fit: contain;
  }

  .qrp-sticker-name {
    margin-top: 1mm;
    font-family: 'Jua', sans-serif;
    font-size: 10pt;
    text-align: center;
    color: #000;
  }

  /* 페이지 설정 */
  @page {
    margin: 5mm;
    size: auto;
  }

  body {
    print-color-adjust: exact;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/QrPrintPage.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;AACxB;;AAEA,OAAO;AACP;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,QAAQ;AACR;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,2CAA2C;EAC3C,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,OAAO;AACP;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,OAAO;AACP;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf;IACE,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA,aAAa;EACb;IACE,wBAAwB;IACxB,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,2BAA2B;EAC7B;;EAEA,eAAe;EACf;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,WAAW;EACb;;EAEA,WAAW;EACX;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IAEE,yBAAyB;EAC3B;AACF","sourcesContent":["/**\n * QR 출력 - QR 스티커 출력 페이지 스타일\n */\n\n.qrprint-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #FFF8E1 0%, #E8F5E9 100%);\n  display: flex;\n  flex-direction: column;\n}\n\n/* 헤더 */\n.qrp-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.qrp-header-center {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  user-select: none;\n  -webkit-user-select: none;\n  cursor: pointer;\n}\n\n.qrp-header h1 {\n  font-family: 'Jua', sans-serif;\n  font-size: 22px;\n  color: #2E7D32;\n  margin: 0;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.qrp-header-spacer {\n  width: 72px;\n}\n\n.qrp-header .btn-back {\n  background: none;\n  border: 2px solid #66BB6A;\n  color: #2E7D32;\n  font-size: 15px;\n  font-weight: 600;\n  padding: 8px 16px;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.qrp-header .btn-back:active {\n  background: #66BB6A;\n  color: #fff;\n}\n\n/* 콘텐츠 */\n.qrp-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 20px;\n  overflow: hidden;\n}\n\n/* 검색 섹션 */\n.qrp-search-section {\n  width: 100%;\n  max-width: 300px;\n  text-align: center;\n}\n\n.qrp-desc {\n  font-family: 'Jua', sans-serif;\n  font-size: 15px;\n  color: #2E7D32;\n  line-height: 1.4;\n  margin-bottom: 8px;\n}\n\n/* 전화번호 표시 */\n.qrp-phone-display {\n  background: #fff;\n  border: 3px solid #C8E6C9;\n  border-radius: 12px;\n  padding: 10px 12px;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.qrp-phone-text {\n  font-family: 'Jua', sans-serif;\n  font-size: 26px;\n  color: #2E7D32;\n  letter-spacing: 2px;\n  user-select: none;\n  -webkit-user-select: none;\n  pointer-events: none;\n}\n\n.qrp-phone-text.placeholder {\n  color: #C8E6C9;\n}\n\n/* 숫자패드 */\n.qrp-numpad {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.qrp-numpad-row {\n  display: flex;\n  gap: 6px;\n  justify-content: center;\n}\n\n.qrp-numpad-key {\n  width: 76px;\n  height: 42px;\n  border: none;\n  border-radius: 10px;\n  background: #fff;\n  color: #333;\n  font-family: 'Jua', sans-serif;\n  font-size: 22px;\n  cursor: pointer;\n  transition: background 0.1s, transform 0.1s;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.qrp-numpad-key:active {\n  background: #E8F5E9;\n  transform: scale(0.95);\n}\n\n.qrp-numpad-key.key-clear {\n  background: #FFEBEE;\n  color: #C62828;\n  font-size: 17px;\n}\n\n.qrp-numpad-key.key-clear:active {\n  background: #FFCDD2;\n}\n\n.qrp-numpad-key.key-backspace {\n  background: #FFF3E0;\n  color: #E65100;\n  font-size: 20px;\n}\n\n.qrp-numpad-key.key-backspace:active {\n  background: #FFE0B2;\n}\n\n/* 조회 버튼 */\n.qrp-search-section .btn-search {\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(135deg, #66BB6A, #43A047);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-size: 18px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n  margin-top: 2px;\n}\n\n.qrp-search-section .btn-search:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.qrp-search-section .btn-search:not(:disabled):active {\n  transform: scale(0.97);\n}\n\n/* 에러 */\n.qrp-error {\n  margin-top: 16px;\n  padding: 12px 16px;\n  background: #FFEBEE;\n  color: #C62828;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n/* 로딩 */\n.qrp-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  margin-top: 80px;\n}\n\n.qrp-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #C8E6C9;\n  border-top-color: #66BB6A;\n  border-radius: 50%;\n  animation: qrp-spin 0.8s linear infinite;\n}\n\n@keyframes qrp-spin {\n  to { transform: rotate(360deg); }\n}\n\n.qrp-loading p {\n  font-size: 16px;\n  color: #546E7A;\n}\n\n/* 결과 섹션 */\n.qrp-result-section {\n  width: 100%;\n  max-width: 440px;\n  animation: qrp-fadeIn 0.3s ease;\n}\n\n@keyframes qrp-fadeIn {\n  from { opacity: 0; transform: translateY(12px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* 전화번호 배너 */\n.qrp-phone-banner {\n  text-align: center;\n  font-family: 'Jua', sans-serif;\n  font-size: 18px;\n  color: #2E7D32;\n  background: #E8F5E9;\n  border-radius: 12px;\n  padding: 10px;\n  margin-bottom: 10px;\n}\n\n/* 선택 컨트롤 */\n.qrp-select-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.btn-select-ctrl {\n  padding: 8px 14px;\n  background: #fff;\n  color: #555;\n  border: 2px solid #E0E0E0;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.btn-select-ctrl.active {\n  background: #E8F5E9;\n  border-color: #66BB6A;\n  color: #2E7D32;\n}\n\n.btn-select-ctrl:active {\n  transform: scale(0.95);\n}\n\n.qrp-select-count {\n  margin-left: auto;\n  font-family: 'Jua', sans-serif;\n  font-size: 15px;\n  color: #777;\n}\n\n/* 회원 카드 리스트 */\n.qrp-member-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 12px;\n  max-height: calc(100vh - 340px);\n  overflow-y: auto;\n}\n\n.qrp-member-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #fff;\n  border: 2px solid #E0E0E0;\n  border-radius: 14px;\n  padding: 10px 14px;\n  cursor: pointer;\n  transition: all 0.15s;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.qrp-member-item.selected {\n  border-color: #66BB6A;\n  background: #F1F8E9;\n}\n\n.qrp-member-item:active {\n  transform: scale(0.98);\n}\n\n.qrp-member-check {\n  font-size: 22px;\n  flex-shrink: 0;\n}\n\n.qrp-member-qr {\n  width: 56px;\n  height: 56px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #f5f5f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.qrp-member-qr img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.qrp-no-qr {\n  font-size: 11px;\n  color: #999;\n}\n\n.qrp-member-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.qrp-member-label {\n  font-family: 'Jua', sans-serif;\n  font-size: 17px;\n  color: #333;\n}\n\n.qrp-member-type {\n  font-size: 12px;\n  color: #999;\n}\n\n/* 액션 버튼 */\n.qrp-action-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.btn-print {\n  width: 100%;\n  padding: 16px;\n  background: linear-gradient(135deg, #66BB6A, #43A047);\n  color: #fff;\n  border: none;\n  border-radius: 14px;\n  font-size: 18px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n\n.btn-print:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.btn-print:not(:disabled):active {\n  transform: scale(0.97);\n}\n\n.qrp-action-buttons .btn-reset {\n  width: 100%;\n  padding: 14px;\n  background: #E0E0E0;\n  color: #555;\n  border: none;\n  border-radius: 14px;\n  font-size: 17px;\n  font-weight: 700;\n  font-family: 'Jua', sans-serif;\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n\n.qrp-action-buttons .btn-reset:active {\n  transform: scale(0.97);\n}\n\n/* 전체화면 복귀 오버레이 */\n.qrp-fs-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 200;\n  cursor: pointer;\n  animation: qrp-fadeIn 0.2s ease;\n}\n\n.qrp-fs-popup {\n  background: #fff;\n  border-radius: 20px;\n  padding: 32px 28px;\n  max-width: 320px;\n  width: 90%;\n  text-align: center;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.3);\n}\n\n.qrp-fs-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n}\n\n.qrp-fs-popup h3 {\n  font-family: 'Jua', sans-serif;\n  font-size: 20px;\n  color: #333;\n  margin: 0 0 8px;\n}\n\n.qrp-fs-popup p {\n  font-size: 15px;\n  color: #666;\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* ============================================\n * 인쇄 전용 스타일 (화면에는 숨김)\n * ============================================ */\n\n.qrp-print-area {\n  display: none;\n}\n\n@media print {\n  /* 글로벌 요소 초기화 */\n  html, body {\n    background: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  .app {\n    min-height: auto !important;\n    display: block !important;\n  }\n\n  .qrprint-page {\n    min-height: auto !important;\n    background: none !important;\n    display: block !important;\n  }\n\n  .qrp-header,\n  .qrp-content,\n  .qrp-fs-overlay {\n    display: none !important;\n  }\n\n  /* 인쇄 영역 표시 */\n  .qrp-print-area {\n    display: flex !important;\n    flex-wrap: wrap;\n    gap: 4mm;\n    padding: 2mm;\n    justify-content: flex-start;\n  }\n\n  /* QR 스티커 한 장 */\n  .qrp-sticker {\n    width: 40mm;\n    height: 45mm;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    border: 0.5px dashed #ccc;\n    padding: 2mm;\n    page-break-inside: avoid;\n  }\n\n  .qrp-sticker-qr {\n    width: 32mm;\n    height: 32mm;\n    object-fit: contain;\n  }\n\n  .qrp-sticker-name {\n    margin-top: 1mm;\n    font-family: 'Jua', sans-serif;\n    font-size: 10pt;\n    text-align: center;\n    color: #000;\n  }\n\n  /* 페이지 설정 */\n  @page {\n    margin: 5mm;\n    size: auto;\n  }\n\n  body {\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
